import { Col, Row, Form, Input, Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const Login = () => {
  const navigate = useNavigate();
  const onFinish = async (values) => {
    try {
      const { data: response } = await axios.post("/login", values);
      Cookies.set("auth-token", response.data.token);
      axios.defaults.headers.common["Authorization"] = response.data.token;
      if (response?.data?.role) {
        var ciphertext = CryptoJS.AES.encrypt(
          response.data.role || 1,
          "J8Lw2Be[CdBZhf/!3?}973Z5O'uNtY4N"
        ).toString();
        if (ciphertext) {
          localStorage.setItem("items", ciphertext);
        }

        navigate("/dashboard");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  return (
    <div className="login">
      <Row className="login-form">
        <Col span={24} className="login-content">
          <img
            src="http://thecharmingtreasure.in:4000/uploads/Logo.svg"
            alt="logo"
            className="loing-logo"
          />
          <Form layout="vertical" autoComplete="off" onFinish={onFinish}>
            <Form.Item
              name="phone"
              label="Email ID | Phone Number"
              rules={[{ required: true, message: "Phone Number is required" }]}
            >
              <Input placeholder="User Name" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: "Password is required" }]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Login
              </Button>
              {/* <p style={{ padding: "10px 0" }}>
                Forget your password ?{" "}
                <a href={"/"} alt="">
                  Click Here
                </a>
              </p> */}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
export default Login;
